export const DRUG_TEST_CATEGORY_COLUMNS = [
  {
    Header: "Test Code",
    accessor: "TestCode",
    id: "TestCode"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Drug Test",
    accessor: "DrugTest",
    id: "DrugTest"
  },
  {
    Header: "Alcohol Test",
    accessor: "AlcoholTest",
    id: "AlcoholTest"
  },
  {
    Header: "Active",
    accessor: "Status",
    id: "Status"
  }
];
